export const headers = { 'Authorization': `Bearer ${process.env.REACT_APP_strapiToken}` };
